export default "__VITE_ASSET__Sta9x_4X__"